




























import { Component, Vue } from 'vue-property-decorator';
import '@/styles/MCQ.scss';
import {GeneralService} from '../services/general-service';
import config from '../services/api-config';
import router from '../router';
import store from '../store';


@Component({
  components: {
  }
})

export default class MCQSubject extends Vue {
private service = new GeneralService();
private entities: GActivity[] = []; 
private level_id; 
private isPastPaper = false;
private longShortPastPaper = false;
private isCustom = false;
private isShortQuestions = false;
private isLongQuestions = false;

public selectSubject(id, name){
    this.$store.state.selectSubject = id;
    this.$store.state.selectSubjectName = name;
    const pastPaper = this.longShortPastPaper ? '&past=true' : ''
    if (this.isPastPaper){
        router.push('quiz?type=pastpaper')
    } else if (this.isCustom) {
        router.push('customexam')
    } else if (this.isShortQuestions) {
        router.push('quiz?type=shortquestions' + pastPaper)
    } else if (this.isLongQuestions) {
        router.push('quiz?type=longquestions' + pastPaper)
    }
    else {
        router.push('quiz')
    }
}

private goBack() {
    if (this.isShortQuestions || this.isLongQuestions)
      this.$router.push('selectEL')
    else
        this.$router.push('mcqtype')                      
  }

getImgUrl(pet) {
    if (pet[pet.length - 1] == ' ') {
        pet = pet.substring(0, pet.length-1);
    }
    const images = require.context('@/assets/images/icons/', false, /\.svg$/);
    try{   
        return images('./' + pet + ".svg")
    } catch{
        // return images('./error.png')
    }
}

mounted() {
    this.level_id = localStorage[config.classLevl];

    if (this.level_id == '' || this.level_id == undefined || this.level_id == 'null') {
        router.push('select');
    }

    if (this.$route.query.type && this.$route.query.type == 'pastpaper'){
        this.isPastPaper = true;
    }

    if (this.$route.query.type && this.$route.query.type == 'customexam'){
        this.isCustom = true;
    }
    
    if (this.$route.query.type && this.$route.query.type == 'shortquestions'){
        this.isShortQuestions = true;
    }

    if (this.$route.query.type && this.$route.query.type == 'longquestions'){
        this.isLongQuestions = true;
    }

    if (this.$route.query.past && this.$route.query.past == 'true'){
        this.longShortPastPaper = true;
    }

    this.service.subjects(this.level_id)
        .then(result => { this.entities = result;})
        .catch(err => { console.error(`Error: ${err.message}`); 
    });

    const footer = document.getElementById('footer');

    if (footer !== null){
      footer.classList.add("mcqsubject");
    }
    
};

    
}

